import React, { useState } from 'react';
import { Container, Box, Typography, TextField, Button, MenuItem, Accordion, AccordionSummary, AccordionDetails, Tab, Tabs, Link, Checkbox, ListItemText } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import 'react-phone-input-2/lib/style.css';
import { useAuth0 } from '@auth0/auth0-react';
import "../styles/testSearch.css";

const map_questionnaire = {
  q1: { "Yes": 1, "No": 2, "I'm not sure": 3 },
  q1a: {
    "Within the past year": 1,
    "Within the past 2 - 5 years": 2,
    "Within the past 5 - 10 years": 3,
    "More than 10 years ago": 4
  },
  q1b: {
    "I have no concerns about my hearing": 1,
    "I think I might have had hearing loss but it's not bothersome enough to do anything about it right now": 2,
    "I think I might have hearing loss but I don't have the resources to do anything about it right now": 3,
    "I think I might have hearing loss but I don't know where to go for help": 4,
    "I think I might have hearing loss but I don't trust the healthcare system": 5
  },
  q2: { "Yes": 1, "No": 0 },
  q2a: {
    "Right Ear": 1,
    "Left Ear": 2,
    "Both Ears": 3
  },
  q2b: {
    "Right Ear": 1,
    "Left Ear": 2,
    "Both Ears": 3
  },
  q3: { Yes: 1, No: 0 },
  q3a: {
    "Impulse - lasting seconds": 1,
    "Intermittent - lasting minutes": 2,
    "Continuous - lasting hours": 3
  },
  q3b: {
    "Only a few instances": 1,
    "More than a few instances, but spaced over time": 2,
    "Prolonged or continuous exposure over months": 3,
    "Prolonged or continuous exposure over years": 4,
  },
  q4: { Yes: 1, No: 0 },
  q5: {
    "Yes, me": 1,
    "Yes, immediate family member": 2,
    No: 3
  },
  q6: { Yes: 1, No: 0 },
  q6a: {
    "Left, constant": 1,
    "Left, intermittent": 2,
    "Right, constant": 3,
    "Right, intermittent": 4,
  },
  q6bl: { "1": 1, "2": 2, "3": 3, "4": 4, "5": 5 },
  q6br: { "1": 1, "2": 2, "3": 3, "4": 4, "5": 5 },
  q6c: { Yes: 1, No: 0 },
  q7: {
    "High blood pressure": 1,
    "Diabetes": 2,
    "Cardiovascular (heart) disease": 3,
    "Stroke": 4,
    "Dementia / Alzheimer's": 5,
    "Depression": 6,
    "None of these apply": 7
  },
  q8: { "Yes": 1, "No": 0 },
  q8a: {
    "Spinning": 1,
    "Floating": 2,
    "Lightheaded": 3,
    "Disorientation": 4,
    "Off balance or unsteady": 5
  },

  ST1: { True: "1", False: "0" },
  ST2: { True: "1", False: "0" },
  ST3: { True: "1", False: "0" },
  ST4: { True: "1", False: "0" },
  ST5: { True: "1", False: "0" },
  ST6: { True: "1", False: "0" },
  ST7: { True: "1", False: "0" },
  ST8: { True: "1", False: "0" },
  ST9: { True: "1", False: "0" },
  ST10: { True: "1", False: "0" },
  ST11: { True: "1", False: "0" },
  ST12: { True: "1", False: "0" },

  DT2: { "Normal [-10 to 15 dB HL]": 1, "Slight [16 to 25 dB HL]": 2, "Mild [26 to 40 dB HL]": 3, "Moderate [41 to 55 dB HL]": 4, "Moderately Severe [56 to 70 dB HL]": 5, "Severe [71 to 89 dB HL]": 6, "Profound [90+ dB HL]": 7 }, // left
  DT3: { "Normal [-10 to 15 dB HL]": 1, "Slight [16 to 25 dB HL]": 2, "Mild [26 to 40 dB HL]": 3, "Moderate [41 to 55 dB HL]": 4, "Moderately Severe [56 to 70 dB HL]": 5, "Severe [71 to 89 dB HL]": 6, "Profound [90+ dB HL]": 7 },
  DT1: { "Normal [-10 to 15 dB HL]": 1, "Slight [16 to 25 dB HL]": 2, "[Mild 26 to 40 dB HL]": 3, "[Moderate 41 to 55 dB HL]": 4, "[Moderately Severe 56 to 70 dB HL]": 5, "Severe [71 to 89 dB HL]": 6, "Profound [90+ dB HL]": 7 },
  DT4: { "Normal [-10 to 15 dB HL]": 1, "Slight [16 to 25 dB HL]": 2, "Mild [26 to 40 dB HL]": 3, "Moderate [41 to 55 dB HL]": 4, "Moderately Severe [56 to 70 dB HL]": 5, "Severe [71 to 89 dB HL]": 6, "Profound [90+ dB HL]": 7 }, // left
  DT5: { "Normal [-10 to 15 dB HL]": 1, "Slight [16 to 25 dB HL]": 2, "Mild [26 to 40 dB HL]": 3, "Moderate [41 to 55 dB HL]": 4, "Moderately Severe [56 to 70 dB HL]": 5, "Severe [71 to 89 dB HL]": 6, "Profound [90+ dB HL]": 7 },
  DT6: { "Normal [-10 to 15 dB HL]": 1, "Slight [16 to 25 dB HL]": 2, "Mild [26 to 40 dB HL]": 3, "Moderate [41 to 55 dB HL]": 4, "Moderately Severe [56 to 70 dB HL]": 5, "Severe [71 to 89 dB HL]": 6, "Profound [90+ dB HL]": 7 }, // left
  DT7: { "Normal [-10 to 15 dB HL]": 1, "Slight [16 to 25 dB HL]": 2, "Mild [26 to 40 dB HL]": 3, "Moderate [41 to 55 dB HL]": 4, "Moderately Severe [56 to 70 dB HL]": 5, "Severe [71 to 89 dB HL]": 6, "Profound [90+ dB HL]": 7 },
  DT8: { "Normal [-10 to 15 dB HL]": 1, "Slight [16 to 25 dB HL]": 2, "Mild [26 to 40 dB HL]": 3, "Moderate [41 to 55 dB HL]": 4, "Moderately Severe [56 to 70 dB HL]": 5, "Severe [71 to 89 dB HL]": 6, "Profound [90+ dB HL]": 7 }, // left
  DT9: { "Normal [-10 to 15 dB HL]": 1, "Slight [16 to 25 dB HL]": 2, "Mild [26 to 40 dB HL]": 3, "Moderate [41 to 55 dB HL]": 4, "Moderately Severe [56 to 70 dB HL]": 5, "Severe [71 to 89 dB HL]": 6, "Profound [90+ dB HL]": 7 },
  DT10: { "Normal [-10 to 15 dB HL]": 1, "Slight [16 to 25 dB HL]": 2, "Mild [26 to 40 dB HL]": 3, "Moderate [41 to 55 dB HL]": 4, "Moderately Severe [56 to 70 dB HL]": 5, "Severe [71 to 89 dB HL]": 6, "Profound [90+ dB HL]": 7 }, // left
  DT11: { "Normal [-10 to 15 dB HL]": 1, "Slight [16 to 25 dB HL]": 2, "Mild [26 to 40 dB HL]": 3, "Moderate [41 to 55 dB HL]": 4, "Moderately Severe [56 to 70 dB HL]": 5, "Severe [71 to 89 dB HL]": 6, "Profound [90+ dB HL]": 7 },
  DT12: { "Normal [-10 to 15 dB HL]": 1, "Slight [16 to 25 dB HL]": 2, "Mild [26 to 40 dB HL]": 3, "Moderate [41 to 55 dB HL]": 4, "Moderately Severe [56 to 70 dB HL]": 5, "Severe [71 to 89 dB HL]": 6, "Profound [90+ dB HL]": 7 }, // left

  refRec: { "True": 1, "False": 0 },
  refType: { "ENT": 1, "Audiologist": 2, "Tinnitus Management Recs": 3, "Psychologist": 4, "Hearing Devices": 5 },
  followReceived: { "True": 1, "False": 0 },
  followResult: { "Needed medical treatment by a physician": 1, "Hearing loss confirmed": 2, "Patient received hearing assistive device(s) such as hearing aids": 3, "Vestibular or balance dysfunction confirmed": 4 },

};


const Grid3 = ({ children }) => (
  <Box className="test-search__grid test-search__grid--one">
    {children}
  </Box>
);

const Grid2 = ({ children }) => (
  <Box className="test-search__grid test-search__grid--two">
    {children}
  </Box>
);

const EarSection = ({ title, children }) => (
  <Box className="test-search__earSection">
    <Typography variant="h6" className="test-search__earTitle">
      {title}
    </Typography>
    {children}
  </Box>
);

const DbRangeInline = React.memo(function DbRangeInline({
  label,
  name,
  dtRange,
  setDtRange,
  debounceMs = 250,
}) {
  const minKey = `${name}_min`;
  const maxKey = `${name}_max`;

  const committedMin = dtRange[minKey] ?? "";
  const committedMax = dtRange[maxKey] ?? "";

  const [minDraft, setMinDraft] = React.useState(
    committedMin === "" ? "" : String(committedMin)
  );
  const [maxDraft, setMaxDraft] = React.useState(
    committedMax === "" ? "" : String(committedMax)
  );

  React.useEffect(() => {
    const next = committedMin === "" ? "" : String(committedMin);
    setMinDraft(next);
  }, [committedMin]);

  React.useEffect(() => {
    const next = committedMax === "" ? "" : String(committedMax);
    setMaxDraft(next);
  }, [committedMax]);

  const commit = React.useCallback(
    (key, draft) => {
      if (draft === "") {
        setDtRange((p) => ({ ...p, [key]: "" }));
        return;
      }

      if (!/^-?\d+$/.test(draft)) return;

      const n = Number(draft);
      if (!Number.isFinite(n)) return;

      setDtRange((p) => ({ ...p, [key]: n }));
    },
    [setDtRange]
  );

  const timersRef = React.useRef({ min: null, max: null });

  const scheduleCommit = React.useCallback(
    (which, key, draft) => {
      const t = timersRef.current[which];
      if (t) window.clearTimeout(t);
      timersRef.current[which] = window.setTimeout(() => {
        commit(key, draft);
      }, debounceMs);
    },
    [commit, debounceMs]
  );

  React.useEffect(() => {
    const { min, max } = timersRef.current;
    return () => {
      if (min) window.clearTimeout(min);
      if (max) window.clearTimeout(max);
    };
  }, [timersRef]);

  return (
    <Box>
      <Typography variant="body2" className="test-search__dbLabel">
        {label}
      </Typography>

      <Box className="test-search__dbRow">
        <Typography variant="body2">From</Typography>

        <TextField
          size="small"
          type="text"
          name={minKey}
          value={minDraft}
          onChange={(e) => {
            const v = e.target.value;
            setMinDraft(v);
            scheduleCommit("min", minKey, v);
          }}
          onBlur={() => commit(minKey, minDraft)}
          className="test-search__dbInput"
          slotProps={{
            input: { inputMode: "numeric", pattern: "^-?\\d*$" },
          }}
        />

        <Typography variant="body2">to</Typography>

        <TextField
          size="small"
          type="text"
          name={maxKey}
          value={maxDraft}
          onChange={(e) => {
            const v = e.target.value;
            setMaxDraft(v);
            scheduleCommit("max", maxKey, v);
          }}
          onBlur={() => commit(maxKey, maxDraft)}
          className="test-search__dbInput"
          slotProps={{
            input: { inputMode: "numeric", pattern: "^-?\\d*$" },
          }}
        />

        <Typography variant="body2">dB</Typography>
      </Box>
    </Box>
  );
});


const TestSearch = () => {
  const navigate = useNavigate();
  const { getAccessTokenSilently, isAuthenticated, loginWithRedirect } = useAuth0();
  const [mode, setMode] = useState(0);
  const [test, setTest] = useState(0);
  const [dtRange, setDtRange] = useState({});
  const [form, setForm] = useState({
    // questionnaire
    q1: "", q1a: "", q1b: "",
    q2: "", q2a: "", q2b: "",
    q3: "", q3a: "", q3b: "",
    q4: "",
    q5: "",
    q6: "", q6a: "", q6bl: "", q6br: "", q6c: "",
    q7: "",
    q8: "", q8a: "",

    // screening (advanced)
    ST1: "", ST2: "", ST3: "", ST4: "", ST5: "", ST6: "", ST7: "", ST8: "", ST9: "", ST10: "",

    // screening (quick)
    ST11: "", // right ear passed
    ST12: "", // left ear passed

    // diagnostic quick (your current DT selects)
    DT1: "", DT2: "", DT3: "", DT4: "", DT5: "", DT6: "", DT7: "", DT8: "", DT9: "", DT10: "", DT11: "", DT12: "",

    // referral
    refRec: "", refType: "", followReceived: "", followResult: "",
  });


  const QuestionnaireSelect = ({ name, label }) => {
    const options = map_questionnaire[name];

    return (
      <TextField
        select
        fullWidth
        label={label}
        name={name}
        value={form[name]}
        onChange={handleSelectChange}
      >
        <MenuItem value="">Select</MenuItem>
        {Object.entries(options).map(([optionLabel, code]) => (
          <MenuItem key={optionLabel} value={code}>
            {optionLabel}
          </MenuItem>
        ))}
      </TextField>
    );
  };

  const QuestionnaireMultiSelect = ({ name, label }) => {
    const options = map_questionnaire[name];

    return (
      <TextField
        select
        fullWidth
        label={label}
        name={name}
        value={form[name] || []}
        onChange={handleMultiSelectChange}
        slotProps={{
          select: {
            multiple: true,
            renderValue: (selected) =>
              selected
                .map(
                  (val) =>
                    Object.entries(options).find(([_, code]) => code === val)?.[0]
                )
                .join(", "),
          }
        }}
      >
        {Object.entries(options).map(([optionLabel, code]) => (
          <MenuItem key={optionLabel} value={code}>
            <Checkbox checked={(form[name] || []).includes(code)} />
            <ListItemText primary={optionLabel} />
          </MenuItem>
        ))}
      </TextField>
    );
  }; const ReferralSelect = ({ name, label }) => {
    const options = map_questionnaire[name];

    return (
      <TextField
        select
        fullWidth
        label={label}
        name={name}
        value={form[name]}
        onChange={handleSelectChange}
      >
        <MenuItem value="">Select</MenuItem>
        {Object.entries(options).map(([optionLabel, code]) => (
          <MenuItem key={optionLabel} value={code}>
            {optionLabel}
          </MenuItem>
        ))}
      </TextField>
    );
  };

  const ReferralMultiSelect = ({ name, label }) => {
    const options = map_questionnaire[name];

    return (
      <TextField
        select
        fullWidth
        label={label}
        name={name}
        value={form[name] || []}
        onChange={handleMultiSelectChange}
        slotProps={{
          select: {
            multiple: true,
            renderValue: (selected) =>
              selected
                .map(
                  (val) =>
                    Object.entries(options).find(([_, code]) => code === val)?.[0]
                )
                .join(", "),
          }
        }}
      >
        {Object.entries(options).map(([optionLabel, code]) => (
          <MenuItem key={optionLabel} value={code}>
            <Checkbox checked={(form[name] || []).includes(code)} />
            <ListItemText primary={optionLabel} />
          </MenuItem>
        ))}
      </TextField>
    );
  };

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleMultiSelectChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: typeof value === "string" ? value.split(",") : value,
    }));
  };

  const compact = (obj) =>
    Object.fromEntries(
      Object.entries(obj).filter(([_, v]) => v !== "" && v !== undefined && v !== null)
    );

  const buildQuestionnairePayload = () => compact({
    q1: form.q1,
    q1a: form.q1a,
    q1b: form.q1b,
    q2: form.q2,
    q2a: form.q2a,
    q2b: form.q2b,
    q3: form.q3,
    q3a: form.q3a,
    q3b: form.q3b,
    q4: form.q4,
    q5: form.q5,
    q6: form.q6,
    q6a: form.q6a,
    q6bl: form.q6bl,
    q6br: form.q6br,
    q6c: form.q6c,
    q7: form.q7,
    q8: form.q8,
    q8a: form.q8a
  });

  const buildScreeningPayload = () => {
    // quick search uses ST11/ST12
    if (mode === 0) {
      return {
        right_ear_passed: form.ST11,
        left_ear_passed: form.ST12,
      };
    }

    // advanced search uses ST1..ST10
    return {
      hz_500_passed_right: form.ST1,
      hz_500_passed_left: form.ST2,
      hz_1000_passed_right: form.ST3,
      hz_1000_passed_left: form.ST4,
      hz_2000_passed_right: form.ST5,
      hz_2000_passed_left: form.ST6,
      hz_4000_passed_right: form.ST7,
      hz_4000_passed_left: form.ST8,
      hz_6000_passed_right: form.ST9,
      hz_6000_passed_left: form.ST10,
    };
  };

  const buildQuickDiagnosticPayload = () => compact({
    DT1: form.DT1, DT2: form.DT2, DT3: form.DT3, DT4: form.DT4, DT5: form.DT5, DT6: form.DT6,
    DT7: form.DT7, DT8: form.DT8, DT9: form.DT9, DT10: form.DT10, DT11: form.DT11, DT12: form.DT12,
  });

  const buildAdvancedDiagnosticPayload = () => {
    const out = {};
    const keys = ["DT1", "DT2", "DT3", "DT4", "DT5", "DT6", "DT7", "DT8", "DT9", "DT10", "DT11", "DT12"];

    for (const k of keys) {
      const minKey = `${k}_min`;
      const maxKey = `${k}_max`;

      out[minKey] = dtRange[minKey] ?? -10;
      out[maxKey] = dtRange[maxKey] ?? 90;
    }
    return out;
  };

  const buildReferralPayload = () => compact({
    refRec: form.refRec,
    refType: form.refType,
    followReceived: form.followReceived,
    followResult: form.followResult,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    // only call screening endpoint when Screening tab is selected
    if (test === 1) {
      try {
        if (!isAuthenticated) {
          await loginWithRedirect();
          return;
        }
        const token = await getAccessTokenSilently({
          authorizationParams: { audience: process.env.REACT_APP_AUTH0_AUDIENCE },
        });
        const questionaire = buildQuestionnairePayload();
        const referral = buildReferralPayload();
        const diagnostic =
          mode === 0 ? buildQuickDiagnosticPayload() : buildAdvancedDiagnosticPayload();
        const payload = { ...questionaire, ...diagnostic, ...referral };

        const resp = await fetch(
          `${process.env.REACT_APP_API_BASE_URI}/api/tests/diagnostic/search`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payload),
          }
        );
        const data = await resp.json();

        if (!resp.ok) {
          throw new Error(data.error || "Diagnostic test search failed");
        }

        navigate("/testSearchResults", { state: { results: data.diagnostic } })
      } catch (err) {
        const message = err?.message || "Unknown error";
        if (message === "No patient access permissions") {
          alert("No patient access permissions. Contact the system administrator.");
          return;
        }
        alert(message);
        console.error(message);
      }
    } else {
      try {
        if (!isAuthenticated) {
          await loginWithRedirect();
          return;
        }

        const token = await getAccessTokenSilently({
          authorizationParams: { audience: process.env.REACT_APP_AUTH0_AUDIENCE },
        });

        const questionaire = buildQuestionnairePayload();
        const referral = buildReferralPayload();
        const screening = buildScreeningPayload();
        const payload = { ...questionaire, ...screening, ...referral };

        const resp = await fetch(
          `${process.env.REACT_APP_API_BASE_URI}/api/tests/screening/search`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payload),
          }
        );

        const data = await resp.json();

        if (!resp.ok) {
          throw new Error(data.error || "Screening test search failed");
        }

        navigate("/testSearchResults", { state: { results: data.screening } });
      } catch (err) {
        const message = err?.message || "Unknown error";
        if (message === "No patient access permissions") {
          alert("No patient access permissions. Contact the system administrator.");
          return;
        }
        alert(message);
        console.error(message);
      }
    }
  };

  return (
    <Container maxWidth="md">
      <Box className="test-search__topbar">
        <Link
          component={RouterLink}
          to="/Search"
          underline="hover"
          color="primary"
          className="test-search__switchLink"
        >
          Switch to Patient Search
        </Link>
      </Box>

      <Box className="test-search">
        <Typography component="h1" variant="h5">
          Test Search
        </Typography>

        <Box component="form" autoComplete="off" onSubmit={handleSubmit} className="test-search__form">
          <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography component="h1" variant="h5">
                Questionnaire
              </Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Box className="test-search__grid test-search__grid--one">
                <Accordion disableGutters>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>Q1</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid3>
                      <QuestionnaireSelect name="q1" label="Have you ever had your hearing tested?" />
                      <QuestionnaireSelect name="q1a" label="When did you last have your hearing tested?" />
                      <QuestionnaireMultiSelect name="q1b" label="If no, why not?" />
                    </Grid3>
                  </AccordionDetails>
                </Accordion>

                <Accordion disableGutters>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>Q2</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid3>
                      <QuestionnaireSelect name="q2" label="Do you think you might have hearing loss, or have you been previously diagnosed with hearing loss?" />
                      <QuestionnaireSelect name="q2a" label="I think I might have hearing loss in:" />
                      <QuestionnaireSelect name="q2b" label="I have been diagnosed with hearing loss in:" />
                    </Grid3>
                  </AccordionDetails>
                </Accordion>

                <Accordion disableGutters>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>Q3</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid3>
                      <QuestionnaireSelect name="q3" label="Have you been exposed to loud noises?" />
                      <QuestionnaireSelect name="q3a" label="What type of noise have you been exposed to most often?" />
                      <QuestionnaireSelect name="q3b" label="What is the approximate duration of your noise exposure?" />
                    </Grid3>
                  </AccordionDetails>
                </Accordion>

                <Accordion disableGutters>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>Q4</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid3>
                      <QuestionnaireSelect name="q4" label="Do you have any ear pain, ear fullness, or drainage?" />
                    </Grid3>
                  </AccordionDetails>
                </Accordion>

                <Accordion disableGutters>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>Q5</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid3>
                      <QuestionnaireMultiSelect name="q5" label="Have you or an immediate family member had ear surgery?" />
                    </Grid3>
                  </AccordionDetails>
                </Accordion>

                <Accordion disableGutters>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>Q6</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid3>
                      <QuestionnaireSelect name="q6" label="Have you ever had any tinnitus in your ears?" />
                      <QuestionnaireMultiSelect name="q6a" label="Which ear have you had tinnitus?" />
                      <QuestionnaireSelect name="q6bl" label="How bothersome is your tinnitus in your left ear?" />
                      <QuestionnaireSelect name="q6br" label="How bothersome is your tinnitus in your right ear?" />
                      <QuestionnaireSelect name="q6c" label="Does the tinnitus sound like your heartbeat?" />
                    </Grid3>
                  </AccordionDetails>
                </Accordion>

                <Accordion disableGutters>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>Q7</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid3>
                      <QuestionnaireMultiSelect name="q7" label="Do you have any of the following diagnoses?" />
                    </Grid3>
                  </AccordionDetails>
                </Accordion>

                <Accordion disableGutters>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>Q8</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid3>
                      <QuestionnaireSelect name="q8" label="In the past 6 months, have you experienced dizziness, balance problems, or balance-related falls?" />
                      <QuestionnaireMultiSelect name="q8a" label="How would you describe your symptoms?" />
                    </Grid3>
                  </AccordionDetails>
                </Accordion>

              </Box>
            </AccordionDetails>
          </Accordion>
          <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography component="h1" variant="h5">
                Referral
              </Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Box className="test-search__grid test-search__grid--one">
                <Grid3>
                  <ReferralSelect name="refRec" label="Received Referral?" />
                  <ReferralMultiSelect name="refType" label="Type of Referral" />
                  <ReferralSelect name="followReceived" label="Follow-up Received" />
                  <ReferralMultiSelect name="followResult" label="Follow-up Result" />
                </Grid3>
              </Box>
            </AccordionDetails>
          </Accordion>

          <Tabs value={mode} onChange={(e, v) => setMode(v)} className="test-search__tabs">
            <Tab label="Quick Search" />
            <Tab label="Advanced Search" />
          </Tabs>
          <Box className="test-search__tabsWrap">
            <Tabs
              value={test}
              onChange={(e, v) => setTest(v)}
              variant="fullWidth"
            >
              <Tab label="Screening" />
              <Tab label="Diagnostic" />
            </Tabs>
          </Box>

          {mode === 0 && test === 0 && (
            <Box>
              <Typography variant="h6" className="test-search__sectionHeading">Quick Screening Search</Typography>
              <Box className="test-search__grid test-search__grid--two">
                <Box className="test-search__earSection">
                  <Typography variant="h6" className="test-search__earTitle">
                    Left Ear
                  </Typography>
                  <Grid3>
                    <QuestionnaireSelect name="ST12" label="Left ear passed" />
                  </Grid3>
                </Box>
                <Box className="test-search__earSection">
                  <Typography variant="h6" className="test-search__earTitle">
                    Right Ear
                  </Typography>

                  <Grid3>
                    <QuestionnaireSelect name="ST11" label="Right ear passed" />
                  </Grid3>
                </Box>
              </Box>
            </Box>
          )}

          {mode === 0 && test === 1 && (
            <Box>
              <Typography variant="h6" className="test-search__sectionHeading">Quick Diagnostic Search</Typography>

              <Box className="test-search__grid test-search__grid--two">
                <Box className="test-search__earSection">
                  <Typography variant="h6" className="test-search__earTitle">
                    Left Ear
                  </Typography>

                  <Grid3>
                    <QuestionnaireSelect name="DT2" label="Left ear threshold at 500 Hz" />
                    <QuestionnaireSelect name="DT4" label="Left ear threshold at 1000 Hz" />
                    <QuestionnaireSelect name="DT6" label="Left ear threshold at 2000 Hz" />
                    <QuestionnaireSelect name="DT8" label="Left ear threshold at 4000 Hz" />
                    <QuestionnaireSelect name="DT10" label="Left ear threshold at 6000 Hz" />
                    <QuestionnaireSelect name="DT12" label="Left ear threshold at 8000 Hz" />
                  </Grid3>
                </Box>
                <Box className="test-search__earSection">
                  <Typography variant="h6" className="test-search__earTitle">
                    Right Ear
                  </Typography>

                  <Grid3>
                    <QuestionnaireSelect name="DT1" label="Right ear threshold at 500 Hz" />
                    <QuestionnaireSelect name="DT3" label="Right ear threshold at 1000 Hz" />
                    <QuestionnaireSelect name="DT5" label="Right ear threshold at 2000 Hz" />
                    <QuestionnaireSelect name="DT7" label="Right ear threshold at 4000 Hz" />
                    <QuestionnaireSelect name="DT9" label="Right ear threshold at 6000 Hz" />
                    <QuestionnaireSelect name="DT11" label="Right ear threshold at 8000 Hz" />
                  </Grid3>
                </Box>
              </Box>
            </Box>
          )}

          {mode === 1 && test === 0 && (
            <Box>
              <Typography variant="h6" className="test-search__sectionHeading">Advanced Screening Search</Typography>

              <Box className="test-search__grid test-search__grid--two">
                <Box className="test-search__earSection">
                  <Typography variant="h6" className="test-search__earTitle">
                    Left Ear
                  </Typography>

                  <Grid3>
                    <QuestionnaireSelect name="ST2" label="Heard 500 Hz in left ear?" />
                    <QuestionnaireSelect name="ST4" label="Heard 1000 Hz in left ear?" />
                    <QuestionnaireSelect name="ST6" label="Heard 2000 Hz in left ear?" />
                    <QuestionnaireSelect name="ST8" label="Heard 4000 Hz in left ear?" />
                    <QuestionnaireSelect name="ST10" label="Heard 6000 Hz in left ear?" />
                  </Grid3>
                </Box>
                <Box className="test-search__earSection">
                  <Typography variant="h6" className="test-search__earTitle">
                    Right Ear
                  </Typography>

                  <Grid3>
                    <QuestionnaireSelect name="ST1" label="Heard 500 Hz in right ear?" />
                    <QuestionnaireSelect name="ST3" label="Heard 1000 Hz in right ear?" />
                    <QuestionnaireSelect name="ST5" label="Heard 2000 Hz in right ear?" />
                    <QuestionnaireSelect name="ST7" label="Heard 4000 Hz in right ear?" />
                    <QuestionnaireSelect name="ST9" label="Heard 6000 Hz in right ear?" />
                  </Grid3>
                </Box>
              </Box>
            </Box>
          )}

          {mode === 1 && test === 1 && (
            <Box>
              <Typography variant="h6" className="test-search__sectionHeading">Advanced Diagnostic Search</Typography>

              <Grid2>
                <EarSection title="Left Ear">
                  <Box className="test-search__grid test-search__grid--one">
                    <DbRangeInline label="Left ear threshold at 500 Hz" name="DT2" dtRange={dtRange} setDtRange={setDtRange} />
                    <DbRangeInline label="Left ear threshold at 1000 Hz" name="DT4" dtRange={dtRange} setDtRange={setDtRange} />
                    <DbRangeInline label="Left ear threshold at 2000 Hz" name="DT6" dtRange={dtRange} setDtRange={setDtRange} />
                    <DbRangeInline label="Left ear threshold at 4000 Hz" name="DT8" dtRange={dtRange} setDtRange={setDtRange} />
                    <DbRangeInline label="Left ear threshold at 6000 Hz" name="DT10" dtRange={dtRange} setDtRange={setDtRange} />
                    <DbRangeInline label="Left ear threshold at 8000 Hz" name="DT12" dtRange={dtRange} setDtRange={setDtRange} />
                  </Box>
                </EarSection>

                <EarSection title="Right Ear">
                  <Box className="test-search__grid test-search__grid--one">
                    <DbRangeInline label="Right ear threshold at 500 Hz" name="DT1" dtRange={dtRange} setDtRange={setDtRange} />
                    <DbRangeInline label="Right ear threshold at 1000 Hz" name="DT3" dtRange={dtRange} setDtRange={setDtRange} />
                    <DbRangeInline label="Right ear threshold at 2000 Hz" name="DT5" dtRange={dtRange} setDtRange={setDtRange} />
                    <DbRangeInline label="Right ear threshold at 4000 Hz" name="DT7" dtRange={dtRange} setDtRange={setDtRange} />
                    <DbRangeInline label="Right ear threshold at 6000 Hz" name="DT9" dtRange={dtRange} setDtRange={setDtRange} />
                    <DbRangeInline label="Right ear threshold at 8000 Hz" name="DT11" dtRange={dtRange} setDtRange={setDtRange} />
                  </Box>
                </EarSection>
              </Grid2>
            </Box>
          )}

          <Button variant="contained" className="test-search__submit" data-cy="search_submit_btn" type="submit">
            Search
          </Button>
        </Box>
      </Box>
    </Container>
  );
}

export default TestSearch;